import React from "react";
import { RolesDropdownCommon } from "./RolesDropdownCommon";

interface RolesDropdownProps {
  componentLabel?: string;
  defaultValue?: string;
  currentTeam?: string;
  type?: string;
  required?: boolean;
  onChange?: (_event: any) => void;
}

/**
 * Roles dropdown component
 */
export const RolesDropdown = (
  props: RolesDropdownProps,
): React.ReactElement => {
  const dropdownProps: any = {
    componentLabel: props.componentLabel,
    defaultValue: props.defaultValue,
    visualStyle: "autoComplete",
    onChange: props.onChange,
  };

  if (props.required) {
    dropdownProps.required = props.required;
  }

  if (props.type) {
    dropdownProps.type = props.type;
  }

  return <RolesDropdownCommon {...dropdownProps} />;
};
